import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import asObject from 'utils/objects/asObject.util';

import {
  CLEAN_TRANSACTION_DATA,
  TRANSACTION_CREATE_FAILURE,
  TRANSACTION_CREATE_REQUEST,
  TRANSACTION_CREATE_SUCCESS,
} from 'checkout/constants';

const DEFAULT = {
  isFetching: false,
  errorMessage: null,
  successful: null,
  authenticated: false,
  response: null,
};

const MAP = Object.freeze({
  [TRANSACTION_CREATE_REQUEST]: (state) => ({ ...state, isFetching: true, successful: null, errorMessage: null }),
  [TRANSACTION_CREATE_SUCCESS]: (state, action) => ({
    ...state,
    isFetching: false,
    successful: true,
    response: action.response,
    authenticated: action.authenticated || false,
  }),
  [TRANSACTION_CREATE_FAILURE]: (state, action) => ({
    ...state,
    successful: false,
    isFetching: false,
    errorMessage: action.errorMessage,
  }),
  [CLEAN_TRANSACTION_DATA]: (state) => ({
    ...state,
    isFetching: false,
    successful: null,
    response: null,
    errorMessage: null,
  }),
});

const transactionCreateReducer = (state, action) =>
  (MAP[action && action.type] || alwaysSame)(state || { ...DEFAULT }, asObject(action));

// noinspection JSUnusedGlobalSymbols
export default transactionCreateReducer;
